
<template>
  <base-card>
    <template slot="title">
      {{ $t('agenda')}}
    </template>
    <template v-slot:content>
      <div v-if="!loading">
        <the-calendar ></the-calendar>
      </div>
      <card-loading-transparent v-if="loading"></card-loading-transparent>
      <!-- <div v-if="!loading && !tasks.length">
        {{ $t('tasks.none') }}
      </div> -->
    </template>
    <template slot="actions">
      <p></p>
      <!-- <v-btn text small class="text-capitalize" color="blue-grey">{{ $tc('see_all',3) }}</v-btn> -->
    </template>
  </base-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';
import TheCalendar from '../../shared/TheCalendar2.vue';
// import BaseInfoCardMarker from '../../shared/base_components/BaseInfoCardMarker.vue';

export default {
  name: 'CalendarCard',
  //mixins: [ validations ],
  components: {
    TheCalendar
    // BaseInfoCardMarker
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      month: '',
      tasks: [
        // {name: 'Lorem', start_at: '12/12/1212', due_at: '12/12/1212'}, 
      ],
    }
  },
  methods: {
    getAgenda() {
      this.loading = true
      Api.Agenda.index({month: this.month}).then(r=> r.data).then(d => {
        this.tasks = [...d]
      }).finally(()=> {
        setTimeout(() => {
          this.loading = false
        }, 1200);
      })
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    // this.getAgenda()
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>